/*
 * @Author: June 1601745371@qq.com
 * @Date: 2024-03-08 11:01:18
 * @LastEditors: June 1601745371@qq.com
 * @LastEditTime: 2024-05-18 15:28:37
 * @FilePath: \github\Pdf-Editor\src\plugins\i18n\lang\zh.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import el_zh from 'element-plus/dist/locale/zh-cn.mjs'
export default {
  el: el_zh.el,
  systemg: {
    error: '系统出错',
  },
  message: {
    test: '测试',
    edit: '编辑',
    template: '模板',
    chatgpt: '智能',
    material: '素材',
    text: '文字',
    image: '图片',
    tool: '工具',
    layer: '图层',
    help: '帮助',
    close: '关闭',
    pages: '页面',
    addPage: '添加页面',
    allPages: '全部',
    currentPage: '当前页',
    showSafeLine: '显示安全线',
    hideSafeLine: '隐藏安全线',
    draggingCanvas: '拖拽画布',
    showBloodsLine: '显示出血线',
    hideBloodsLine: '隐藏出血线',
    imageResolution: '图片分辨率',
    imageQuality: '图片质量',
    exportFormat: 'Export格式',
    exportRange: 'Export范围',
    selfRange: '自定义Export',
    ignoreBloods: '忽略出血',

    exportImages: 'Export图片',
    exportPDF: 'ExportPDF',
    exportPSD: 'ExportPSD',
    exportJSON: 'Export JSON',
    exportSVG: 'Export SVG',
    quantityPerPage: '每页数量',
    blankEdges: '边缘留白',

    inviteCollaboration: '邀请协同',
    github: 'Github',
    downloadFiles: '下载文件',
    uploadFiles: '上传文件',
    saveTemplate: '保存模板',

    undo: 'Revocation',
    redo: '重做',
    group: '组合',
    ungroup: '解组',
    ruler: '标尺',
    union: '并集',
    difference: '减去顶层',
    intersection: '交集',
    xor: '排除重叠',

    createDesign: '创建设计',
    referenceLine: '参考线',

    codeStyle: '码样式',
    codeContent: '码内容',
    codeMargin: '码边距',
    nonMargin: '无边距',
    standardMargin: '标准边距',
    errorRate: '容错率',

    searchTemp: '搜索模板',
    recommendTemp: '推荐模板',
    myTemp: '我的模板',
    myPurchases: '我的购买',
    myFavorites: '我的收藏',
    teamTemp: '团队模板',

    searchMat: '搜索素材',
    recommendMat: '推荐素材',
    myBookmarksMat: '我的收藏',
    myPurchasesMat: '我的购买',
    straightLine: '直线',

    searchText: '搜索文字',
    addTitle: '点击添加标题文字',
    addSubtitle: '点击添加副标题文字',
    addBodyText: '点击添加正文文字',
    direction: '竖向',
    transverse: '横向',
    hollowOut: '镂空',
    recommendText: '推荐素材',
    myBookmarksText: '我的收藏',
    myPurchasesText: '我的购买',
    myTemplate: '我的模板',
    teamTemplate: '团队模板',

    uploadImages: '上传图片',
    searchImages: '搜索图片',
    recommendImages: '推荐图片',
    myBookmarks: '我的收藏',
    teamTemplates: '团队模板',
    all: '全部',
    endOfContent: '到底啦~',

    searchTools: '搜索工具',
    barCode: '条形码',
    fabricTable:"表格",
    barCodeTips: '快速生成一维码,支持4种码制',
    QRCode: '二维码',
    QRCodeTips: '快速生成二维码,支持13种样式',
    AICutoutImage: 'AI抠图',
    AICutoutImageTips: '运用AI技术，实现智能识别',
    ColorFillImage: '图片填充颜色',
    ColorFillImageTips: '图片颜色填充，常用改背景色',

    searchLayer: '搜索图层',
    beginnerGuide: "新手入门",
    userGuide: '使用教程',
    shortcuts: '快捷键',
    suggestions: '反馈建议',
    onlineSupport: '在线客服',

    model: '模型',
    dragAndDropFiles: '拖拽文件到这里，或者',
    selectFileUpload: '选择文件上传',
    imageLimit2MTips: '为了更好的体验，请上传2M以内的图片',
    common: '通用',
    portrait: '人像',
    rawImage: '原始图像',
    resultImage: '结果图像',
    clear: '清除',
    download: '下载',
    uploading: '上传中',
    completeImageCutout: '完成抠图',

    files: '文件',
    title: '标题',
    subtitle: '副标题',
    horizontalText: '横排正文',
    verticalText: '竖排正文',
    hollowOutText: '镂空正文',
    circularText: '环形正文',
    shape: '形状',
    module: '组件',
  },
  default: {
    textValue: '双击修改文字',
    cancel: '取消',
    ok: '确定',
    cleanUp: '清除',
    direction: '方向'
  },
  style: {
    canvas: '画布',
    canvasSize: '画布尺寸',
    style: '样式',
    layer: '图层',
    width: '宽',
    height: '高',
    w: '宽',
    h: '高',
    horizontal: '水平',
    vertical: '垂直',
    bleedingLine: '出血线',
    rightAngle: '直角',
    fillet: '圆角',
    unit: '单位',
    card: '名片',
    singlePage: '单页',
    custom: '自定义',
    canvasFill: '画布填充',
    lockAspectRatio: '锁定宽高比',
    unlockAspectRatio: '解除宽高比',
    applyCanvasToAll: '应用画布到全部',
    solidColorFill: '纯色填充',
    imageFill: '图片填充',
    gradientFill: '渐变填充',
    gridFill: '网格填充',
    shapeFill: '形状填充',
    intelligentFill: '智能填充',
    canvasMask: '画布蒙版',
    opacity: '不透明度',
    safetyLine: '安全线',
    minimumSizeLimit: '尺寸限制最小为',
    maximumSizeLimit: '尺寸限制最大为',

    leftAlign: '左对齐',
    rightAlign: '右对齐',
    topAlign: '上对齐',
    bottomAlign: '下对齐',
    center: '居中',
    centerHorizontal: '水平居中',
    verticalCenter: '垂直居中',
    top: '上移',
    bottom: '下移',
    down: '置底',
    up: '置顶',
    code: '码制',
    codeValue: '码值',
    bgColor: '背景颜色',
    codeColor: '条码颜色',
    enableBorder: '启用边框',
    codeStyle: '码样式',
    codeContent: '码内容',
    codeMargin: '码边距',
    noMargin: '无边距',
    standardMargin: '标准边距',
    solidBorder: '实线边框',
    dashedBorder: '虚线边框',
    borderStyle: '边框样式',
    borderColor: '边框颜色',
    borderThickness: '边框粗细',
    enableShadow: '启用阴影',
    horizontalShadow: '水平阴影',
    verticalShadow: '垂直阴影',
    fuzzyDistance: '模糊距离',
    shadowColor: '阴影颜色',
    flipVertical: '垂直翻转',
    flipHorizontal: '水平翻转',
    cropImage: '裁剪',
    byShape: '按形状',
    byAspectRatio: '按纵横比',
    square: '(方形)',
    direction: '(纵向)',
    transverse: '(横向)',
    enableMask: '启用蒙版',
    maskColor: '蒙版颜色',
    randomShape: '随机形状',
    replaceimage: '替换图片',
    resetStyle: '重置样式',
    setAsBg: '设为背景',
    gradientAngle: '渐变角度',
    horizontalPosition: '水平位置',
    verticalPosition: '垂直位置',
    strength: '强度',
    variance: '方差',
    size: '尺寸',
    randomGeneration: '随机生成',
    colorSelect: '颜色选择',
    customize: '自定义',
    graphScale: '图形缩放',
    lineThickness: '线条粗细',
    verticalSpace: '垂直间距',
    horizontalSpace: '水平间距',
    rotationAngle: '旋转角度',
    colorNumber: '颜色数量',

    enableFilters: '启用滤镜',
    grayscale: '灰度',
    average: '平均',
    luminosity: '光度',
    bright: '明亮',
    mode: '模式',
    inversion: '倒置',
    sharpening: '锐化',
    concaveConvex: '凹凸',
    matrix: '矩阵',
    sepia: '棕褐色',
    blackAndWhite: '黑白色',
    brownie: '布朗尼',
    vintageColor: '年份色',
    technicolor: '特艺彩',
    kodachrome: '柯达彩',
    polaroid: '宝丽来',
    color: '色彩',
    brightness: '亮度',
    contrast: '对比',
    saturation: '饱和',
    colorful: '鲜艳',
    hue: '色调',
    noise: '噪音',
    pixel: '像素',
    vague: '模糊',

    axis: '轴',
    position: '位置',
    enableImgStroke: '启用图片描边',
    onlyShowContours: '只显示轮廓',
    onlyTransparentLayer: '只支持透明图层',
    enableStroke: '启用描边',
    strokeWidth: '描边厚度',
    cornerStyle: '角落风格',
    bevel: '斜面',
    round: '圆形',
    miter: '斜接',
    strokeColor: '描边颜色',

    enableShading: '启用底纹',
    shadingMode: '底纹模式',
    shadingImage: '底纹图片',
    collage: '拼贴',
    enableGradient: '启用渐变',
    blendMode: '混合模式',
    enableCut: 'Cut',
    specialEffects: '特效',
    highlight: '高亮',
    increaseFontSize: '增大字号',
    decreaseFontSize: '减小字号',
    bold: '加粗',
    italic: '斜体',
    underline: '下划线',
    strikethrough: '删除线',
    clearFormat: '清除格式',
    formatPainter: '格式刷',
    increaseIndent: '增大缩进',
    decreaseIndent: '增大缩进',
  },
  waterMark: {
    text: "画布水印",
    modalTitle: "配置水印",
    setting: {
      name: "名称",
      size: "大小",
      angle: "角度",
      position: {
        label: "位置",
        lt: "左上角",
        rt: "右上角",
        lb: "左下角",
        rb: "右下角",
        full: "平铺"
      }
    }
  },

  gpt: {
    openGPTTitle: '开通ChatGPT-4',
    openGPTIntro: '开通GPT服务',
    
    gptTitle: '体验GPT',
    gptIntro: '体验GPT服务'
  }
};
